import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";

export const defaultLanguage = "en";

export const resources = {
  en: { translation: en },
} as const;

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLanguage,
  fallbackLng: defaultLanguage,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
